import { useState } from "react";
import getTimeSince from "utilities/js/TimeManager";
import { approveFollowRequest, declineFollowRequest } from "utilities/js/callouts/CalloutFactory";
import { useQueryClient } from "@tanstack/react-query";


const NotificationItem = props => {

    const queryClient = useQueryClient();
    const [disabledResponseButtons, setDisabledResponseButtons] = useState(false);
    
    async function acceptFollow(){
        setDisabledResponseButtons(true);

        approveFollowRequest({followId: props.notification.related_id}).then((response) => {
            queryClient.invalidateQueries({ queryKey: ['notifications'] });
        }).catch(error => {
            // showErrorToast(this, 'Your request cannot be processed at this time');
            console.log('unable to complete approve follow request');
        }).finally(() => {
            setTimeout(() => {
                setDisabledResponseButtons(false);
            }, 1000)
        })
    }

    async function declineFollow(){
        
        setDisabledResponseButtons(true);
        declineFollowRequest({followId: props.notification.related_id}).then((response) => {
            queryClient.invalidateQueries({ queryKey: ['notifications'] });
        }).catch(error => {
            // showErrorToast(this, 'Your request cannot be processed at this time');
            console.log('unable to complete decline follow request');
        }).finally(() => {
            setTimeout(() => {
                setDisabledResponseButtons(false);
            }, 1000)
        })
    }
    function getActionButtons(){
        if(props.notification.notificationType === 'followRequest' && props.notification.response_status === 'pending' && props.notification.related_id){

            if(disabledResponseButtons){
                return (
                    <div className="notification-list-item-response-buttons">
                        <button className="nav-button h-button notification-list-item-accept" disabled>
                            Accept
                        </button>
                        <button className="nav-button-red h-button notification-list-item-decline" disabled>
                            Decline
                        </button>
                    </div>
                );

            }else{
                return (
                    <div className="notification-list-item-response-buttons">
                        <button className="nav-button h-button notification-list-item-accept" onClick={acceptFollow}>
                            Accept
                        </button>
                        <button className="nav-button-red h-button notification-list-item-decline" onClick={declineFollow}>
                            Decline
                        </button>
                    </div>
                );

            }

        }else if(props.notification.notificationType === 'followRequest' && props.notification.response_status === 'accepted'){
            return (
                <div className="notification-message-preview">Approved!</div>
            )
        }else if(props.notification.notificationType === 'followRequest' && props.notification.response_status === 'declined'){
            return (
                <div className="notification-message-preview">Declined</div>
            )
        }
        return (<></>)
    }

    function getUI(){
        // if(props.notification.notificationType === 'followRequest' && props.notification.response_status === 'pending' && props.notification.related_id){

        //     return (
        //         <div key={props.notification._id} className={"notification-list-item " + (props.notification.read_status === false ? 'unread' : '')}>
        //             <div className="notification-list-item-top">
        //                 <div className="notification-sender">
        //                     {props.notification.created_by.username}
        //                 </div>
        //                 <div className="notification-date">
        //                     {getTimeSince(props.notification.created_date)}
        //                 </div>
        //             </div>
        //             <div className="notification-list-item-bottom">
        //                 <div className="notification-message-preview">
        //                     {props.notification.message.substring(0, 40)}
        //                 </div>
        //             </div>
        //         </div>
        //     );
        // }else{
            return (
                <div key={props.notification._id} className={"notification-list-item " + (props.notification.read_status === false ? 'unread' : '')}>
                    <div className="notification-list-item-top">
                        <div className="notification-sender">
                            {props.notification.created_by.username}
                        </div>
                        <div className="notification-date">
                            {getTimeSince(props.notification.created_date)}
                        </div>
                    </div>
                    <div className="notification-list-item-bottom">
                        <div className="notification-message-preview">
                            {props.notification.message.substring(0, 40)}
                        </div>
                    </div>
                    {getActionButtons()}
                </div>
            );

        // }
    }

    return getUI();    

}

export default NotificationItem;